import {
    ColoursObj,
    MobileSnackBarCard,
    Typography,
    useSnackListStore,
} from '@eventr/common-storybook'
import { AlertColor } from '@mui/material'
import { signal } from '@preact/signals-react'

export const shownedSnackListSignal = signal<string[]>([])
let fontColour = (severity: AlertColor) => {
    switch (severity) {
        case 'error': {
            return ColoursObj.shades.shade5
        }
        case 'warning': {
            return ColoursObj.shades.shade5
        }
        case 'success': {
            return ColoursObj.shades.shade5
        }
        default: {
            return ColoursObj.font.primary
        }
    }
}

export function defaultAddSnack(
    message: string,
    severity: AlertColor,
    stack: boolean = true,
    uniqueMessageId?: string
) {
    const snackListStore = useSnackListStore.getState()
    if (uniqueMessageId) {
        if (shownedSnackListSignal.peek().includes(uniqueMessageId)) return
        shownedSnackListSignal.value = [
            ...shownedSnackListSignal.peek(),
            uniqueMessageId,
        ]
    }
    const uId = snackListStore.getUId()
    if (!stack) snackListStore.clearList()
    snackListStore.addSnackToList(
        <MobileSnackBarCard
            severity={severity}
            onXClick={() => {
                snackListStore.removeSnackFromList(uId)
            }}
        >
            <Typography
                color={fontColour(severity)}
                sx={{
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '400',
                    fontFamily: 'CountryFlags, Inter-100-500',
                    lineHeight: '16px',
                }}
            >
                {message}
            </Typography>
        </MobileSnackBarCard>,
        uId
    )
}
